<template>
  <Notifications
    width="300px"
    :position="notificationPosition"
    @destroy="shoppingActivationStore.destroy"
    @click="shoppingActivationStore.destroy"
    :animation-name="'fade-in'">
    <template #body="props">
      <div
        class="shopping-activation-notification"
        :class="notificationSkin"
        @click="props.close">
        <div class="close"><span>×</span></div>
        <div class="shopping-activation-image" :class="notificationImage"></div>
        <div v-html="props.item.text" />
      </div>
    </template>
  </Notifications>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useShoppingActivationStore } from '@/stores/shoppingActivation.store';

const shoppingActivationStore = useShoppingActivationStore();
const { notificationPosition, notificationSkin, notificationImage } =
  storeToRefs(shoppingActivationStore);
</script>

<style scoped>
.shopping-activation-notification {
  margin: 10px;
  border: 0;
  position: relative;
  display: block;
  text-align: left;
  padding: 15px 30px 15px 65px;
  min-height: 65px;
  color: #fff;
  background: rgba(137, 200, 120, 0.85);
  font-size: 11px;
  @apply font-primary;
}

.shopping-activation-notification:hover {
  background: rgba(60, 60, 60, 0.85) !important;
}

.shopping-activation-notification.BLUE {
  background: rgba(1, 159, 223, 0.85);
}

.shopping-activation-notification.DARK {
  background: rgba(0, 0, 0, 0.85);
}

.shopping-activation-notification.YELLOW {
  background: rgba(255, 199, 44, 0.85);
}

.shopping-activation-image {
  background-repeat: no-repeat;
  position: absolute;
  width: 35px;
  height: 35px;
  overflow: hidden;
  top: 15px;
  left: 15px;
  background-image: url('@/assets/images/shopping-activation-icons.png');
}

.shopping-activation-image.LAST_RESERVATIONS {
  background-position: 0 -105px;
}

.shopping-activation-image.LAST_WEEK_STAYS {
  background-position: 0 -35px;
}

.shopping-activation-image.BEST_RATE_GUARANTEED {
  background-position: 0 -70px;
}

.shopping-activation-image.ADR {
  background-position: 0 -280px;
}

.shopping-activation-image.AVAILABILITY {
  background-position: 0 -315px;
}

.shopping-activation-image.TODAY_BEST_OFFER {
  background-position: 0 -210px;
}

.shopping-activation-notification .close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  overflow: hidden;
  cursor: pointer;
  background-color: #333;
  color: #e4e4e4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  font-family: sans-serif;
}

.shopping-activation-notification .close span {
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
  display: block;
  transform: translateY(-1px);
}

.shopping-activation-notification.DARK .close {
  background-color: #c2c2c2;
  color: #fbfbfb;
}
.shopping-activation-notification .close:hover {
  background-color: #a9a9a9;
  color: #f9f9f9;
}
</style>
